<template>
	<div class="con">
		<div class="head">
			<div class="header">
					<h1>住院信息</h1>
					<p>请选择相关服务</p>
				</div>
		</div>
		<div class="nav-list">
			<div class="nav-big" v-for="item in navList" @click="navBtn(item.id)">
				<img :src="item.img" />
				<div class="nav-big-con">
					<div class="nav-con-left">
						<div class="text">{{item.text}}</div>
						<div class="richtext">{{item.richText}}</div>
					</div>
					<van-icon name="arrow" size="20px" color="#ccc" />
				</div>
			</div>
		</div>
		<div class="list">
			<div class="bot-title">服务</div>
			<div class="list-display">
				<div v-for="item in botlist" class="botlist" @click="botBtn(item.id)">
					<img :src="item.img" />
					<div class="bot-text">{{item.text}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 住院服务页面组件
	export default {
		name: 'inpatient',
		data() {
			return {
				msg: '住院服务', // 页面标题
				list: [], // 预留列表数据
				cardUserInfo: '', // 就诊卡信息
				userInfo: '', // 用户信息
				loading: false, // 加载状态
				// 导航列表数据
				navList: [
				{
					id: 0,
					text: "押金缴纳",
					richText: '请进行住院押金缴纳',
					img: require('../assets/payCost.png'),
					to: '/inpatientPayCost'
				},
			],
				// 服务列表数据
				botlist: [{
					id: 0,
					text: "住院报告",
					img: require('../assets/inHospital.png'),
					to: '/inpatientInfo'
				},
				{
					id: 1,
					text: "缴费记录",
					img: require('../assets/inprecord.png'),
					to: '/inpatientDeposit'
				},
			],

			}
		},
		methods: {
			//添加就诊卡
			addCard() {
				this.$router.push('/patient')
			},
			//通用导航方法
			navigateTo(url) {
				if(this.cardUserInfo != '' && this.cardUserInfo != undefined) {
					this.$router.push(url)
				} else {
					this.$toast("请添加就诊卡")
				}
			},
			navBtn(e) {
				let toUrl = this.navList[e].to;
				this.navigateTo(toUrl)
			},
			botBtn(e) {
				let toUrl = this.botlist[e].to;
				this.navigateTo(toUrl)
			},
		},
		mounted() {
			this.loading = true;
			try {
				// 从本地存储获取就诊卡信息
				const cardInfo = localStorage.getItem('cardUserInfo');
				const userInfo = localStorage.getItem('userInfo');
				
				if(cardInfo) {
					this.cardUserInfo = JSON.parse(cardInfo);
				}
				
				if(userInfo) {
					this.userInfo = JSON.parse(userInfo);
				}
			} catch (error) {
				console.error('加载数据失败:', error);
				this.$toast('加载数据失败，请重试');
			} finally {
				this.loading = false;
			}
		},
		created() {
		},
	}
</script>

<style scoped>
	.con {
		min-height: 100vh;
		background-color: #f5f7fa;
		padding-bottom: 30px;
	}
	
	.head {
		margin-bottom: 20px;
	}
	
	.header {
		background: linear-gradient(135deg, #27bec4 0%, #1a9ea4 100%);
		padding: 15px;
		color: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
		position: sticky;
		top: 0;
		z-index: 100;
	}
	
	.header h1 {
		font-size: 18px;
		font-weight: 700;
		margin: 0 0 5px 0;
		text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
	}
	
	.header p {
		font-size: 14px;
		margin: 0;
		opacity: 0.9;
	}

	.nav-list {
		font-size: 15px;
		margin-top: 20px;
	}
	
	.nav-big {
		padding: 15px;
		display: flex;
		align-items: center;
		margin: 10px 15px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
		transition: all 0.3s ease;
	}
	
	.nav-big:active {
		background-color: #f0f9ff;
	}
	
	.nav-big img {
		margin-right: 15px;
		width: 50px;
		height: 50px;
	}
	
	.text {
		font-weight: 700;
		font-size: 18px;
		text-align: start;
	}
	
	.richtext {
		color: #999;
		font-size: 14px;
		margin-top: 4px;
	}
	
	.nav-big-con {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: calc(100% - 65px);
	}
	
	.list {
		padding: 15px;
		margin: 15px;
		background-color: #fff;
		border-radius: 8px;
		box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
	}
	
	.bot-title {
		padding-left: 10px;
		border-left: 3px solid #27BEC4;
		font-size: 16px;
		font-weight: 700;
		margin-bottom: 15px;
	}
	
	.botlist {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px 0;
		transition: all 0.3s ease;
	}
	
	.botlist:active {
		background-color: #f0f9ff;
		border-radius: 8px;
	}
	
	.botlist img {
		display: block;
		margin: 0 auto 10px;
		width: 50px;
		height: 50px;
	}
	
	.bot-text {
		font-size: 14px;
		text-align: center;
	}
	
	.list-display {
		display: flex;
		justify-content: space-around;
	}
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	/* 响应式设计 */
	@media screen and (max-width: 375px) {
		.card {
			width: 95%;
			padding: 20px 15px;
		}
		
		.card img {
			width: 100px;
			height: 120px;
		}
		
		.nav-big {
			margin: 10px;
			padding: 12px;
		}
		
		.nav-big img {
			width: 40px;
			height: 40px;
		}
		
		.text {
			font-size: 16px;
		}
		
		.richtext {
			font-size: 13px;
		}
	}
</style>